import React, { useCallback, useEffect, useRef, useState } from "react";
import style from "css/calendar.module.css";
import axios from "axios";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Tag,
  TimePicker,
  Upload,
} from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateMeetingTime } from "redux/slices/meetingTimeSlice";
import { closeAlert, openAlert } from "redux/slices/alertSlice";
import RiParticipantBox from "components/menu/riParticipantBox";
import RiEndpointSideBox from "components/menu/riEndpointSideBox";
import { UploadOutlined } from "@ant-design/icons";

export default function Reservepop({
  isOpenRes,
  close,
  schedule,
  getScheduleList,
  PAGE_TYPE,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const meetingTimePayload = useSelector((state) => state.meetingTime);
  const [form] = Form.useForm();

  const [isMore, setIsMore] = useState(false);
  const [isPasswordEnabled, setIsPasswordEnabled] = useState(false);

  const [inputMemberList, setInputMemberList] = useState([]);

  const [treeMemberList, setTreeMemberList] = useState([]);
  const [searchMemberList, setSearchMemberList] = useState([]);
  const [recentMemberList, setRecentMemberList] = useState([]);

  const [isOpenParticpantSideBox, setIsOpenParticpantSideBox] = useState(false);
  const [isOpenEndpointSideBox, setIsOpenEndpointSideBox] = useState(false);

  const [searchEndpointList, setSearchEndpointList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [t11est, setstest] = useState("1324");
  const [newSchedule, setNewSchedule] = useState(schedule);
  const [fileList, setFileList] = useState([]);

  const [dateTimes, setDateTimes] = useState({
    START_DATE: null,
    END_DATE: null,
    START_TIME: null,
    END_TIME: null,
  });
  const [vcType, setVcType] = useState("");

  useEffect(() => {
    setNewSchedule({
      PROCESS_TYPE: schedule.PROCESS_TYPE || "C",
      TITLE: schedule.TITLE || "",
      CONTENTS: schedule.CONTENTS || "",
      OPEN_YN: schedule.OPEN_YN || "Y",
      RECORD_YN: schedule.RECORD_YN || "N",
      MAIL_YN: schedule.MAIL_YN || "Y",
      MEETING_PW: schedule.MEETING_PW || "",
      PARTICIPANT_LIST: schedule.PARTICIPANT_LIST || [],
      ENDPOINT_LIST: schedule.ENDPOINT_LIST || [],
      ATTACHMENT_LIST: schedule.ATTACHMENT_LIST || [],
      SCHEDULE_ID: schedule.SCHEDULE_ID || "",
      SCHEDULE_TYPE: schedule.SCHEDULE_TYPE || [],
    });
    getSystemType();

    setFileList(
      (schedule.ATTACHMENT_LIST || []).map((attachment) => ({
        uid: attachment.FILE_ID,
        name: attachment.ORI_FILE_NM,
        status: "success",
        url: attachment.FILE_URL,
      }))
    );
    setExInfo("");
  }, [isOpenRes]);

  useEffect(() => {
    setNewSchedule({
      PROCESS_TYPE: schedule.PROCESS_TYPE || "C",
      TITLE: schedule.TITLE || "",
      CONTENTS: schedule.CONTENTS || "",
      OPEN_YN: schedule.OPEN_YN || "Y",
      RECORD_YN: schedule.RECORD_YN || "N",
      MAIL_YN: schedule.MAIL_YN || "Y",
      MEETING_PW: schedule.MEETING_PW || "",
      PARTICIPANT_LIST: schedule.PARTICIPANT_LIST || [],
      ENDPOINT_LIST: schedule.ENDPOINT_LIST || [],
      ATTACHMENT_LIST: schedule.ATTACHMENT_LIST || [],
      SCHEDULE_TYPE: schedule.SCHEDULE_TYPE || [],
      SCHEDULE_ID: schedule.SCHEDULE_ID || "",
    });
    closeParticipantSideBox();
    setFileList(
      (schedule.ATTACHMENT_LIST || []).map((attachment) => ({
        uid: attachment.FILE_ID,
        name: attachment.ORI_FILE_NM,
        status: "success",
        url: attachment.FILE_URL,
      }))
    );
    getSystemType();
  }, [schedule]);

  useEffect(() => {
    let startTime = schedule.START_TIME || getReserveDateTime(new Date(), 0);
    let endTime = schedule.END_TIME || getReserveDateTime(new Date(), 30);

    setDateTimes({
      START_DATE: dayjs(startTime).format("YYYY-MM-DD"),
      END_DATE: dayjs(endTime).format("YYYY-MM-DD"),
      START_TIME: dayjs(startTime).format("HH:mm"),
      END_TIME: dayjs(endTime).format("HH:mm"),
    });

    setIsPasswordEnabled(schedule.MEETING_PW !== "" ? true : false);
  }, [
    schedule.START_TIME,
    schedule.END_TIME,
    schedule.START_TIME,
    schedule.END_TIME,
    isOpenRes,
  ]);

  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }

  const getSystemType = () => {
    axios
      .get("/schedule/systemInfo")
      .then((res) => {
        if (res.status === 200) {
          setVcType(res.data.SYSTEM_TYPE);

          if (schedule.SYSTEM_TYPE !== "CD0205") {
            setNewSchedule((pre) => ({
              ...pre,
              SYSTEM_TYPE: res.data.SYSTEM_TYPE,
            }));
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewSchedule((prev) => ({ ...prev, [name]: value }));
  };

  const sDateChange = (date, START_DATE) => {
    dispatch(
      updateMeetingTime({
        ...meetingTimePayload,
        TYPE: "PICKER",
        START_DATE,
      })
    );
    setNewSchedule((pre) => ({
      ...pre,
      START_TIME: START_DATE + " " + dateTimes.START_TIME + ":00",
    }));
    setDateTimes((pre) => ({
      ...pre,
      START_DATE,
    }));
  };
  const eDateChange = (date, END_DATE) => {
    dispatch(
      updateMeetingTime({
        ...meetingTimePayload,
        TYPE: "PICKER",
        END_DATE,
      })
    );
    setNewSchedule((pre) => ({
      ...pre,
      END_TIME: dateTimes.START_DATE + " " + dateTimes.END_TIME + ":00",
    }));
    setDateTimes((pre) => ({
      ...pre,
      END_DATE,
    }));
  };
  const sTimeChange = (time, START_TIME) => {
    if (PAGE_TYPE !== "room") {
      dispatch(
        updateMeetingTime({
          ...meetingTimePayload,
          TYPE: "PICKER",
          START_TIME: START_TIME,
        })
      );
    }
    setNewSchedule((pre) => ({
      ...pre,
      START_TIME: dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00",
    }));
    setDateTimes((pre) => ({
      ...pre,
      START_TIME,
    }));
  };
  const eTimeChange = (time, END_TIME) => {
    if (PAGE_TYPE !== "room") {
      dispatch(
        updateMeetingTime({
          ...meetingTimePayload,
          TYPE: "PICKER",
          END_TIME,
        })
      );
    }
    setNewSchedule((pre) => ({
      ...pre,
      END_TIME: dateTimes.START_DATE + " " + dateTimes.END_TIME + ":00",
    }));
    setDateTimes((pre) => ({
      ...pre,
      END_TIME,
    }));
  };

  const pwOptionChange = (e) => {
    if (isPasswordEnabled) {
      setNewSchedule((pre) => ({
        ...pre,
        MEETING_PW: "",
      }));
    }

    setIsPasswordEnabled(e.target.checked);
  };

  const scheduleTypeChange = (e) => {
    const vcYn = e.target.value;

    setNewSchedule((pre) => ({
      ...pre,
      SCHEDULE_TYPE: vcYn === "Y" ? vcType : "CD0205",
    }));

    if (vcYn !== "Y") {
      setNewSchedule((pre) => ({
        ...pre,
        ENDPOINT_LIST: schedule.ENDPOINT_LIST,
      }));

      setSearchEndpointList(
        searchEndpointList.map((e) => ({ ...e, isChecked: false }))
      );
    }
  };

  const participantChange = (p) => {
    setNewSchedule((pre) => {
      const filteredList = pre.PARTICIPANT_LIST.filter((item) => {
        return p.MEMBER_ID !== item.MEMBER_ID;
      });

      if (p.isChecked) {
        filteredList.push(p);
      }

      return { ...pre, PARTICIPANT_LIST: filteredList };
    });
  };

  const participantDeselect = (pId) => {
    setNewSchedule((pre) => {
      const filteredList = pre.PARTICIPANT_LIST.filter((item) => {
        return pId !== item.MEMBER_ID;
      });

      return { ...pre, PARTICIPANT_LIST: filteredList };
    });

    setSearchMemberList(
      searchMemberList.map((m) =>
        m.MEMBER_ID === pId ? { ...m, isChecked: !m.isChecked } : m
      )
    );

    setRecentMemberList(
      recentMemberList.map((m) =>
        m.MEMBER_ID === pId ? { ...m, isChecked: !m.isChecked } : m
      )
    );
  };

  // default participant input
  const handleInputMemberCheck = (memberIdArr) => {
    let memberId = memberIdArr[memberIdArr.length - 1];

    if (inputMemberList.length === 1) {
      memberId = inputMemberList[0].MEMBER_ID;
    }

    if (Array.isArray(memberIdArr) && memberIdArr.length > 0) {
      const params = { MEMBER_ID: memberId };

      // const url = "/address/detail";
      // let config = {
      //   params: {
      //     MEMBER_ID: memberId,
      //   },
      // };
      axios
        // .get(url, config)
        .post("/user/detail", params)
        .then((res) => {
          if (res.status === 200) {
            let inputSearchMember = {};
            if (res.data !== "") {
              inputSearchMember = res.data;
              inputSearchMember.isChecked = !inputSearchMember.isChecked;
              participantChange(inputSearchMember);
            } else {
              const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

              if (regex.test(memberId)) {
                inputSearchMember.MEMBER_ID = memberId;
                inputSearchMember.MEMBER_NM = memberId;
                inputSearchMember.EMAIL = memberId;
                inputSearchMember.isChecked = !inputSearchMember.isChecked;
                participantChange(inputSearchMember);
              } else {
                const obj = {
                  title: "알림",
                  content: "이메일형식오류입니다.",
                  submitEventHandler: () => {
                    dispatch(closeAlert());
                  },
                };
                dispatch(openAlert(obj));
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleInputMember = (value) => {
    if (value) {
      inputMembers(value);
    } else {
      setInputMemberList([]);
    }
  };

  const inputMembers = (value) => {
    const params = { KET_WORDL: value };
    // const url = "/address/searchList";
    const url = "/user/searchList";
    let config = {
      params: {
        KEY_WORD: value,
      },
    };
    axios
      .post("/user/searchList", params)
      // .get(url, config)
      .then((res) => {
        if (res.status === 200) {
          setInputMemberList(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const endpointDeselect = (eId) => {
    setNewSchedule((pre) => {
      const filteredList = pre.ENDPOINT_LIST.filter((item) => {
        return eId !== item.ENDPOINT_ID;
      });

      return { ...pre, ENDPOINT_LIST: filteredList };
    });

    setSearchEndpointList(
      searchEndpointList.map((e) =>
        e.ENDPOINT_ID === eId ? { ...e, isChecked: !e.isChecked } : e
      )
    );
  };

  const toggleParticipantSideBox = () => {
    setIsOpenEndpointSideBox(false);
    setIsOpenParticpantSideBox(!isOpenParticpantSideBox);
  };

  const toggleEndpointBox = (e) => {
    if (
      newSchedule.SCHEDULE_TYPE === "CD0205" &&
      newSchedule.ENDPOINT_LIST.length === 1
    ) {
      setIsOpenParticpantSideBox(false);
      setIsOpenEndpointSideBox(false);
    } else {
      setIsOpenParticpantSideBox(false);
      setIsOpenEndpointSideBox(true);
    }
  };

  const closeParticipantSideBox = () => {
    setIsOpenParticpantSideBox(false);
  };

  const closeEndpointSideBox = () => {
    setIsOpenEndpointSideBox(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setNewSchedule((prev) => ({
      ...prev,
      START_TIME: dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00",
      END_TIME: dateTimes.START_DATE + " " + dateTimes.END_TIME + ":00",
    }));

    let params = {
      PROCESS_TYPE: newSchedule.PROCESS_TYPE,
      SCHEDULE_ID: newSchedule.SCHEDULE_ID,
      SCHEDULE_TYPE: newSchedule.SCHEDULE_TYPE,
      TITLE: newSchedule.TITLE,
      CONTENTS: newSchedule.CONTENTS,
      START_TIME: dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00",
      END_TIME: dateTimes.START_DATE + " " + dateTimes.END_TIME + ":00",
      FILE_INFO: newSchedule.FILE_INFO,
      OPEN_YN: newSchedule.OPEN_YN,
      RECORD_YN: newSchedule.RECORD_YN,
      MAIL_YN: newSchedule.MAIL_YN,
      MEETING_PW: newSchedule.MEETING_PW,
      PARTICIPANT_LIST: newSchedule.PARTICIPANT_LIST,
      ENDPOINT_LIST: newSchedule.ENDPOINT_LIST,
      ATTACHMENT_LIST: fileList,
      CHANGED: {},
    };

    if (newSchedule.PROCESS_TYPE === "U") {
      changed.sort();
      let data = changed.join(",");
      params.CHANGED = data;
    }

    if (!confirmVal(params)) {
      return;
    }

    const formData = new FormData();
    formData.append("params", JSON.stringify(params));
    fileList.forEach((file) => {
      formData.append("files", file);
    });

    setIsOpenParticpantSideBox(false);
    setIsOpenEndpointSideBox(false);
    setLoading(true);

    if (newSchedule.PROCESS_TYPE === "C") {
      axios
        .post("/schedule/reserve", formData)
        .then((res) => {
          if (res.status === 200) {
            setLoading(false);
            getScheduleList();

            openResConfirm();

            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: "회의가 예약되었습니다.",
              submitEventHandler: () => {
                dispatch(closeAlert());
                closePop();
              },
            };
            dispatch(openAlert(obj));
            setLoading(false);
          }
        })
        .catch((error) => {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: error.response.data,
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          setLoading(false);
        });
    } else {
      axios
        .put("/schedule/reserve", formData)
        .then((res) => {
          if (res.status === 200) {
            const obj = {
              title: t("MESSAGE.NOTIFICATION"),
              content: t("MESSAGE.MODIFY_COMPLETE"),
              submitEventHandler: () => {
                getScheduleList();
                dispatch(closeAlert());
              },
            };
            dispatch(openAlert(obj));
            setLoading(false);
            closePop();
          }
        })
        .catch((error) => {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: error.response.data,
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          setLoading(false);
        });
    }
  };

  const confirmVal = (newSchedule) => {
    let isCorrect = true;

    if (
      newSchedule.TITLE === undefined ||
      newSchedule.TITLE.trim().length === 0
    ) {
      const obj = {
        title: t("MESSAGE.NOTIFICATION"),
        content: t("MESSAGE.TITLE_ERROR"),
        submitEventHandler: () => {
          dispatch(closeAlert());
        },
      };
      dispatch(openAlert(obj));

      isCorrect = false;
      return isCorrect;
    }

    if (
      dayjs(newSchedule.END_TIME).diff(newSchedule.START_TIME) >
      24 * 60 * 60 * 1000
    ) {
      const obj = {
        title: t("MESSAGE.NOTIFICATION"),
        content: t("MESSAGE.OVER_24HOURS"),
        submitEventHandler: () => {
          dispatch(closeAlert());
        },
      };
      dispatch(openAlert(obj));
      return;
    }

    if (isPasswordEnabled) {
      if (
        newSchedule.MEETING_PW.length < 4 ||
        newSchedule.MEETING_PW.length > 20
      ) {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.MEETING_PW_ALERT"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
        return;
      }
    }

    return isCorrect;
  };

  const closePop = () => {
    setIsMore(false);
    setIsPasswordEnabled(false);
    setIsOpenParticpantSideBox(false);
    setIsOpenEndpointSideBox(false);
    setSearchEndpointList([]);
    setNewSchedule({});
    setghostrun(true);
    setchanged([]);
    close();
    closeEndpointSideBox();
    closeParticipantSideBox();
  };

  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  const [ghostdata, setghostdata] = useState([]);
  const [ghostrun, setghostrun] = useState(true);
  useEffect(() => {
    if (
      newSchedule.SCHEDULE_ID !== "" &&
      newSchedule.SCHEDULE_ID !== undefined &&
      newSchedule.PROCESS_TYPE === "U"
    ) {
      if (ghostrun) {
        setghostdata(newSchedule);
        setchanged([]);
        setghostrun(false);
      }
    }
  }, [ghostrun, ghostdata, newSchedule]);
  const [check, setcheck] = useState(false);
  const [changed, setchanged] = useState([]);

  const listcheck = (val1, val2, type) => {
    if (
      newSchedule.PROCESS_TYPE === "U" &&
      val1 !== undefined &&
      val2 !== undefined
    ) {
      if (type === "PARTICIPANT") {
        for (var i = 0; i < val1.length; i++) {
          let flag = false;
          for (var k = 0; k < val2.length; k++) {
            if (val1[i].MEMBER_ID === val2[k].MEMBER_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        for (var j = 0; j < val2.length; j++) {
          let flag = false;
          for (var q = 0; q < val1.length; q++) {
            if (val1[q].MEMBER_ID === val2[j].MEMBER_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        return true;
      } else if (type === "ENDPOINT") {
        for (var z = 0; z < val1.length; z++) {
          let flag = false;
          for (var x = 0; x < val2.length; x++) {
            if (val1[z].ENDPOINT_ID === val2[x].ENDPOINT_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        for (var c = 0; c < val2.length; c++) {
          let flag = false;
          for (var v = 0; v < val1.length; v++) {
            if (val1[v].ENDPOINT_ID === val2[c].ENDPOINT_ID) {
              flag = true;
            }
          }
          if (!flag) {
            return flag;
          }
        }
        return true;
      }
    }
  };

  useEffect(() => {
    let flags = false;
    if (ghostdata.TITLE !== newSchedule.TITLE) {
      if (!changed.includes("회의 명")) {
        setchanged(changed.concat("회의 명"));
      }
      flags = true;
    } else {
      if (changed.includes("회의 명")) {
        setchanged(changed.filter((data) => data !== "회의 명"));
      }
    }
    if (ghostdata.CONTENTS !== newSchedule.CONTENTS) {
      flags = true;
      if (!changed.includes("회의 내용")) {
        setchanged(changed.concat("회의 내용"));
      }
    } else {
      if (changed.includes("회의 내용")) {
        setchanged(changed.filter((data) => data !== "회의 내용"));
      }
    }
    if (
      ghostdata.START_TIME !==
      dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00"
    ) {
      flags = true;
      if (!changed.includes("시작 시간")) {
        setchanged(changed.concat("시작 시간"));
      }
    } else {
      if (changed.includes("시작 시간")) {
        setchanged(changed.filter((data) => data !== "시작 시간"));
      }
    }
    if (
      ghostdata.END_TIME !==
      dateTimes.END_DATE + " " + dateTimes.END_TIME + ":00"
    ) {
      flags = true;
      if (!changed.includes("종료 시간")) {
        setchanged(changed.concat("종료 시간"));
      }
    } else {
      if (changed.includes("종료 시간")) {
        setchanged(changed.filter((data) => data !== "종료 시간"));
      }
    }

    if (
      ghostdata.PARTICIPANT_LIST !== undefined &&
      newSchedule.PARTICIPANT_LIST !== undefined
    ) {
      if (
        !listcheck(
          ghostdata.PARTICIPANT_LIST,
          newSchedule.PARTICIPANT_LIST,
          "PARTICIPANT"
        )
      ) {
        flags = true;
        if (!changed.includes("참석자")) {
          setchanged(changed.concat("참석자"));
        }
      } else {
        if (changed.includes("참석자")) {
          setchanged(changed.filter((data) => data !== "참석자"));
        }
      }
    }

    if (
      ghostdata.ENDPOINT_LIST !== undefined &&
      newSchedule.ENDPOINT_LIST !== undefined
    ) {
      if (
        !listcheck(
          ghostdata.ENDPOINT_LIST,
          newSchedule.ENDPOINT_LIST,
          "ENDPOINT"
        )
      ) {
        flags = true;
        if (!changed.includes("회의실")) {
          setchanged(changed.concat("회의실"));
        }
      } else {
        if (changed.includes("ENDPOINT")) {
          setchanged(changed.filter((data) => data !== "회의실"));
        }
      }
    }
    let optionboolean = false;
    if (ghostdata.MAIL_YN !== newSchedule.MAIL_YN) {
      flags = true;
      optionboolean = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.MEETING_PW !== newSchedule.MEETING_PW) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.RECORD_YN !== newSchedule.RECORD_YN) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (ghostdata.OPEN_YN !== newSchedule.OPEN_YN) {
      optionboolean = true;
      flags = true;
      if (!changed.includes("회의 정보")) {
        setchanged(changed.concat("회의 정보"));
      }
    } else {
      if (!optionboolean) {
        if (changed.includes("회의 정보")) {
          setchanged(changed.filter((data) => data !== "회의 정보"));
        }
      }
    }
    if (flags) {
      setcheck(true);
    } else {
      setcheck(false);
      setchanged([]);
    }
  }, [newSchedule, dateTimes]);

  const tagRender = (props) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 5,
          backgroundColor: "#ededed",
          borderColor: "#ededed",
          borderRadius: "15.5px",
          padding: "6px 13px 6px 11.5px",
          color: "#121212",
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {label}
      </Tag>
    );
  };

  const props = {
    onRemove: (file) => {
      setFileList((prev) => {
        const index = prev.indexOf(file);
        const newFileList = prev.slice();
        newFileList.splice(index, 1);
        return newFileList;
      });
    },
    beforeUpload: (file) => {
      setFileList((prev) => [...prev, file]);
      return false;
    },
    fileList,
  };

  const [isOpenResConfirm, setIsOpenResConfirm] = useState(false);
  const openResConfirm = () => {
    setIsOpenResConfirm(true);
  };
  const closeResConfirm = () => {
    setIsOpenResConfirm(false);
  };

  const [endpointInfo, setEndpointInfo] = useState({
    name: "",
    location: "",
    img: "",
    fixtures: [],
  });

  const getEndpointInfo = useCallback(() => {
    if (schedule.ENDPOINT_LIST === undefined) return;
    axios
      .get("/schedule/getendpointInfo", {
        params: {
          ENDPOINT_ID: schedule.ENDPOINT_LIST[0].ENDPOINT_ID,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          setEndpointInfo(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [schedule.ENDPOINT_LIST]);
  useEffect(() => {
    getEndpointInfo();
  }, [getEndpointInfo, schedule]);

  const resetSelect = (date) => {};

  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const popupRef = useRef();

  const isGlobalAlertOpen = useSelector((state) => state.alert.display);

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const [exInfo, setExInfo] = useState("");
  const handleKeyDownEx = (e) => {
    if (e.key === "Enter") {
      if (exInfo === "") {
        return;
      }
      if (!isValidEmail(exInfo)) {
        const obj = {
          title: "알림",
          content: "이메일형식오류입니다.",
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
        return;
      } else {
        let p = {
          MEMBER_ID: exInfo,
          MEMBER_NM: exInfo,
          EMAIL: exInfo,
          isChecked: true,
        };

        const exists = newSchedule.PARTICIPANT_LIST.some(
          (item) => item.EMAIL === p.EMAIL
        );

        setNewSchedule((pre) => {
          if (p.isChecked && !exists) {
            return {
              ...pre,
              PARTICIPANT_LIST: [...pre.PARTICIPANT_LIST, p],
            };
          }
          return { ...pre };
        });
        if (exists) {
          alert("중복이 존재");
        } else {
          setExInfo("");
        }
      }
    }
  };
  const removeparticipants = (param) => {
    setNewSchedule((pre) => {
      const filteredList = pre.PARTICIPANT_LIST.filter((item) => {
        return param !== item.EMAIL;
      });

      return { ...pre, PARTICIPANT_LIST: filteredList };
    });
  };

  const participantChangeEx = (p) => {
    setNewSchedule((pre) => {
      const filteredList = pre.PARTICIPANT_LIST.filter((item) => {
        return p.MEMBER_ID !== item.MEMBER_ID;
      });

      return { ...pre, PARTICIPANT_LIST: filteredList };
    });
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      //  Picker가 열려 있으면 외부 클릭으로 간주하지 않음
      if (isOpenEndpointSideBox) return;
      if (isPickerOpen) return;
      if (isGlobalAlertOpen) return; // Alert 팝업 열려 있으면 무시
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        close(); // 원하는 외부 클릭 처리
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPickerOpen, close, isGlobalAlertOpen, isOpenEndpointSideBox]);

  const systemtype = useSelector((state) => state.system.isOnline);

  return (
    <div className={style.ripopWrapper} ref={popupRef}>
      <div className={style.ripopHeader}>
        <div className={style.ripopHeader1}>
          <div title={endpointInfo.name}>{endpointInfo.name}</div>
          <img
            src={process.env.REACT_APP_CLIENT_URL + "img/menu/close.png"}
            alt="close"
            onClick={() => closePop()}
          />
        </div>
        <div>{endpointInfo.location}</div>
      </div>
      <div className={style.ripopBody}>
        <div className={style.ripopBody1}>
          <img alt="" src={endpointInfo.img} />
          {/* <img
            alt=""
            src={process.env.REACT_APP_CLIENT_URL + "img/sample.png"}
          /> */}
        </div>
        <div className={style.ripopBody2}>
          <p>예약일시</p>
          <div>
            {" "}
            <DatePicker
              className={style.ripop_datepicker}
              size="large"
              // disabled
              disabledDate={(current) =>
                current.isBefore(dayjs().subtract(1, "day"))
              }
              value={
                dateTimes.START_DATE === ""
                  ? null
                  : dayjs(
                      dateTimes.START_DATE + " " + dateTimes.START_TIME + ":00"
                    )
              }
              name="START_DATE"
              placeholder={t("PLACEHOLDER.INPUT.RESERVE_START_DATE")}
              onChange={sDateChange}
              onOpenChange={(open) => setIsPickerOpen(open)}
            />
          </div>
          <div>
            <TimePicker.RangePicker
              className={style.ripop_timepicker}
              size="large"
              format={"HH:mm"}
              minuteStep={10}
              value={[
                dateTimes.START_DATE === ""
                  ? null
                  : dayjs(dateTimes.START_DATE + " " + dateTimes.START_TIME),
                dateTimes.endTime === ""
                  ? null
                  : dayjs(dateTimes.START_DATE + " " + dateTimes.END_TIME),
              ]}
              onChange={(time) => {
                sTimeChange(time, time[0].format("HH:mm"));
                eTimeChange(time, time[1].format("HH:mm"));
              }}
              placeholder={["시작시간", "종료시간"]}
              onOpenChange={(open) => setIsPickerOpen(open)}
            />
          </div>
        </div>
        <div className={style.ripop_line} />
        <div className={style.ripopBody3}>
          <p>회의명</p>
          <input
            type="text"
            name="TITLE"
            value={newSchedule.TITLE ?? ""}
            onChange={handleChange}
            placeholder={t("PLACEHOLDER.INPUT.WRITE_TITLE")}
          />
        </div>
        <div className={style.ripop_line} />
        <div className={style.ripopBody3}>
          <p>참석자</p>
          <div className={style.participantsList}>
            {newSchedule.PARTICIPANT_LIST?.map((data) => (
              <div className={style.participantBox}>
                <div className={style.partiInfo}>
                  <div className={style.participantImg}></div>
                  <div className={style.participantInfo}>
                    <font>{data.MEMBER_NM}</font>
                    <font>{data.EMAIL}</font>
                  </div>
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    removeparticipants(data.EMAIL);
                  }}
                >
                  X
                </div>
              </div>
            ))}
          </div>
          <div>
            <div
              className={style.participantsBtn}
              onClick={() => setIsOpenParticpantSideBox(true)}
            >
              <div>+</div>
              <div>참석자 추가</div>
            </div>
            <div className={style.participantEx}>
              <input
                type="text"
                placeholder="외부 참석자의 이매일주소를 입력하고 Enter를 눌러주세요"
                onKeyDown={handleKeyDownEx}
                onChange={(e) => setExInfo(e.target.value)}
                value={exInfo}
              />
            </div>
          </div>
        </div>

        {systemtype === false ? (
          ""
        ) : (
          <>
            <div className={style.ripop_line} />
            <div className={style.ripopBody3}>
              <p>회의실</p>
              <div className={style.participantsList}>
                {newSchedule.ENDPOINT_LIST?.map((data) => (
                  <div className={style.participantBox}>
                    <font>{data.ENDPOINT_NM}</font>
                  </div>
                ))}
              </div>
              <div
                className={style.participantsBtn}
                onClick={() => setIsOpenEndpointSideBox(true)}
              >
                <div>+</div>
                <div>추가</div>
              </div>
            </div>
          </>
        )}

        <div className={style.ripop_line} />
        <div>
          <p>비품정보</p>
          <div>
            {endpointInfo.fixtures != null
              ? endpointInfo.fixtures.map((fixture, index) => {
                  return (
                    <>
                      {index !== 0 ? (
                        <font key={index}>, {fixture}</font>
                      ) : (
                        <font key={index}>{fixture}</font>
                      )}
                    </>
                  );
                })
              : ""}
          </div>
        </div>

        {systemtype === false ? (
          ""
        ) : (
          <>
            <div className={style.ripop_line} />
            <div className={style.ripopBody3}>
              <p>화상회의 여부</p>
              <Radio.Group
                name="VC_YN"
                optionType="button"
                value={newSchedule.SCHEDULE_TYPE !== "CD0205" ? "Y" : "N"}
                className={style.res_popup_radio_group}
                onChange={scheduleTypeChange}
                disabled={newSchedule.PROCESS_TYPE === "U" ? true : false}
              >
                <Radio value="Y" className={style.res_popup_radio_scheduleType}>
                  {t("common.button.yes")}
                </Radio>
                <Radio value="N" className={style.res_popup_radio_scheduleType}>
                  {t("common.button.no")}
                </Radio>
              </Radio.Group>
            </div>
            <div className={style.ripop_line} />
            <div className={style.ripopBody3}>
              <p>녹화 여부</p>
              <Row gutter={0} style={{ height: "30px" }}>
                <Col span={12}>
                  <Form.Item>
                    <div className={style.res_popup_input_label}>
                      <Checkbox
                        name="RECORD_YN"
                        checked={newSchedule.RECORD_YN === "Y"}
                        value="Y"
                        className={style.res_popup_checkbox}
                        onChange={handleChange}
                        disabled={
                          newSchedule.SCHEDULE_TYPE === "CD0205" ? true : false
                        }
                      >
                        {t("common.button.yes")}
                      </Checkbox>
                      <Checkbox
                        name="RECORD_YN"
                        checked={
                          newSchedule.RECORD_YN === "N" ||
                          newSchedule.RECORD_YN === undefined
                        }
                        value="N"
                        onChange={handleChange}
                        className={style.res_popup_checkbox}
                        disabled={
                          newSchedule.SCHEDULE_TYPE === "CD0205" ? true : false
                        }
                      >
                        {t("common.button.no")}
                      </Checkbox>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <div className={style.ripop_line} />
            <div className={style.ripopBody4}>
              <p>암호 설정</p>
              <Form.Item style={{ marginBottom: "0px" }}>
                <div className={style.res_popup_input_label}>
                  <font style={{ marginRight: "7px" }}>사용</font>
                  <Checkbox
                    name="PW_OPTION"
                    checked={isPasswordEnabled}
                    onChange={pwOptionChange}
                    className={style.res_popup_checkbox}
                    disabled={
                      newSchedule.SCHEDULE_TYPE === "CD0205" ? true : false
                    }
                  ></Checkbox>{" "}
                  <Input.Password
                    name="MEETING_PW"
                    onChange={handleChange}
                    value={newSchedule.MEETING_PW ?? ""}
                    style={{
                      width: "calc(230px)",
                      marginLeft: "20px",
                      height: "30px",
                    }}
                    disabled={
                      !(
                        isPasswordEnabled &&
                        newSchedule.SCHEDULE_TYPE !== "CD0205"
                      )
                    }
                  />
                </div>
              </Form.Item>
            </div>
          </>
        )}

        <div className={style.ripop_line} />
        <div className={style.ripopBody3}>
          <p>메일 전송</p>
          <Row gutter={0} style={{ height: "30px" }}>
            <Col span={11}>
              <Form.Item>
                <div className={style.res_popup_input_label}>
                  <Checkbox
                    name="MAIL_YN"
                    checked={
                      newSchedule.MAIL_YN === "Y" ||
                      newSchedule.MAIL_YN === undefined
                    }
                    value="Y"
                    className={style.res_popup_checkbox}
                    onChange={handleChange}
                  >
                    {t("common.button.yes")}
                  </Checkbox>
                  <Checkbox
                    name="MAIL_YN"
                    checked={newSchedule.MAIL_YN === "N"}
                    value="N"
                    onChange={handleChange}
                    className={style.res_popup_checkbox}
                  >
                    {t("common.button.no")}
                  </Checkbox>
                </div>
              </Form.Item>
            </Col>
          </Row>
        </div>

        {/* <div className={style.ripop_line} />
        <div className={style.ripopBody3}>
          <p>회의목록</p>
          <Form.Item style={{ marginBottom: "0px" }}>
            <div className={style.res_popup_input_label}>
              <Radio.Group
                name="OPEN_YN"
                onChange={handleChange}
                value={newSchedule.OPEN_YN}
                optionType="button"
                buttonStyle="solid"
              >
                <Radio value="Y" className={style.res_popup_radio} style={{}}>
                  {t("BTN.PUBLIC")}
                </Radio>
                <Radio value="N" className={style.res_popup_radio}>
                  {t("BTN.PRIVATE")}
                </Radio>
              </Radio.Group>
              <div
                className={style.res_popup_openYn_label}
                style={{ marginTop: "10px", color: " #d9d9d9" }}
              >
                {t("MESSAGE.MEETING_LIST_NOTICE")}
              </div>
            </div>
          </Form.Item>
        </div> */}
        <div className={style.ripop_line} />
        <div className={style.ripopBody3}>
          <p>메모</p>
          <Form.Item style={{ marginBottom: "14px" }}>
            <div className={style.res_popup_input_label}></div>
            <Input.TextArea
              rows={2}
              name="CONTENTS"
              value={newSchedule.CONTENTS ?? ""}
              placeholder={t("PLACEHOLDER.INPUT.WRITE_CONTENT")}
              onChange={handleChange}
              className={style.res_popup_input_value}
            />
          </Form.Item>
        </div>
        <div className={style.ripop_line} />
        <div className={style.ripopBody3}>
          <p>첨부파일</p>

          <Form.Item style={{ marginBottom: "20px" }}>
            <div className={style.res_popup_input_label}>
              <Upload {...props} fileList={fileList}>
                <Button className={style.res_popup_upload_btn}>
                  {t("BTN.ADD")}
                  <UploadOutlined />
                </Button>
              </Upload>
            </div>
          </Form.Item>
        </div>
      </div>
      <div className={style.ripopFooter} onClick={handleSubmit}>
        예약하기
      </div>

      <RiParticipantBox
        isOpenParticpantSideBox={isOpenParticpantSideBox}
        closeParticipantSideBox={closeParticipantSideBox}
        participantChange={participantChange}
        treeMemberList={treeMemberList}
        searchMemberList={searchMemberList}
        recentMemberList={recentMemberList}
        setTreeMemberList={setTreeMemberList}
        setSearchMemberList={setSearchMemberList}
        setRecentMemberList={setRecentMemberList}
        schedule={newSchedule}
      />
      <RiEndpointSideBox
        isOpenEndpointSideBox={isOpenEndpointSideBox}
        closeEndpointSideBox={closeEndpointSideBox}
        searchEndpointList={searchEndpointList}
        setSearchEndpointList={setSearchEndpointList}
        schedule={newSchedule}
        setSchedule={setNewSchedule}
        dateTimes={dateTimes}
        pickerOpen={setIsPickerOpen}
      />
    </div>
  );
}
